module.exports = "/* global itag_l1:true itag_language:true */\n/* exported itag_l1 itag_language */\n\n'use strict';\n\n// Omniture Tags\n\nvar itag_l1 = 'US';\nvar itag_language = 'en';\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/main/resources/static/scripts/omniture.js
// module id = 406
// module chunks = 0